import { ReactComponent as LogoHover } from './logo-hover.svg';
import { ReactComponent as LogoActive } from './logo-active.svg';
import { ReactComponent as LogoDefault } from './logo-default.svg';

const LogoIcons = { LogoHover, LogoActive, LogoDefault };

export default LogoIcons;
